var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.logOff ? _c('section', [_c('h3', [_vm._v("로그인")]), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-text-field', {
    staticClass: "d-inline-block",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "type": "text",
      "label": "아이디"
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-text-field', {
    staticClass: "d-inline-block",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "type": "password",
      "label": "비밀번호"
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.login();
      }
    }
  }, [_vm._v("로그인")])], 1)]) : _vm._e(), _vm.logOn ? _c('section', [_c('h3', [_vm._v("로그아웃")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.logout();
      }
    }
  }, [_vm._v("로그아웃")])], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }